export default {

    apiAddEmployee(data) {
        return this.request(this.api().ADD_EMPLOYEE, data)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetAllEmployees(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_EMPLOYEES, payload)
            .exec().log()
            .mapresults((res) => {
                return {
                    data: res.data,
                    total: res.count
                }
            })
            .get();
    },

    apiExportEmployees(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().EXPORT_EMPLOYEES, payload)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .mapresults((response) => {
                return response;
            })
            .get();
    },

    apiGetEmployeeById(urldata = {}) {
        return this.request(this.api().GET_EMPLOYEE_BY_ID)
            .urltransform(urldata)
            .exec()
            .log()
            .get();
    },

    apiUpdateEmployee(data, urldata = {}) {
        let payload = {
            ...data
        }
        return this.request(this.api().UPDATE_EMPLOYEE, payload)
            .urltransform(urldata).exec().log().get();
    },

    apiDeleteEmployee(urldata = mixins.params()) {

        return this.request(this.api().DELETE_EMPLOYEE)
            .urltransform(urldata)
            .exec().log().get();
    },
}